// Module
var code = `<div class="participant-info-header"> <div class="profile-photo-wrapper"> <profile-photo model="vm.model"></profile-photo> </div> <div class="participant-info"> <div class="participant-name">{{vm.model.Name}}</div> <div class="participant-email">{{vm.model.Email}}</div> </div> </div>`;
// Exports
export default code;